import {
  PayoutOrderListItem,
  PayoutOrderListItemResponse,
  TransactionStatus,
} from '@/models/payout-order/payout-order-list.model';
import { formatDateTimePassedUtil } from '@/utils/format-date-time-passed.util';

export const payoutOrdersListApiToDto = (payoutOrderApi: PayoutOrderListItemResponse): PayoutOrderListItem => {
  const isPaymentStatusInfo = Boolean(payoutOrderApi.paymentStatusInfo.length);
  const isBlockHoldMessage = Boolean(payoutOrderApi.blockHoldMessage);

  const colorStatusMap = {
    [TransactionStatus.PAID]: 'Paid',
    [TransactionStatus.PENDING]: 'Pending',
    [TransactionStatus.CANCELLED]: 'Cancelled',
    [TransactionStatus.PROCESSED]: 'Processed',
    [TransactionStatus.STUCK]: 'Stuck',
    [TransactionStatus.HOLD]: 'Hold',
    [TransactionStatus.INITIATED]: 'Initiated',
    [TransactionStatus.UNCOMPLETED]: 'Uncompleted',
    [TransactionStatus.MANUAL_CANCEL]: 'Manual cancel',
    [TransactionStatus.MANUAL_PAID]: 'Manual paid',
    [TransactionStatus.KYC_VERIFICATION]: 'Waiting KYC result',
    [TransactionStatus.WAITING_PSP_COMPLETION]: 'Waiting PSP completion',
    [TransactionStatus.FRAUD_CANCELLED]: 'Fraud cancelled',
  };

  return {
    createdAt: formatDateTimePassedUtil(payoutOrderApi.createdAt) ?? '—',
    playerId: payoutOrderApi.playerId,
    playerEmail: payoutOrderApi.playerEmail,
    playerTagList: payoutOrderApi?.playerTagList ?? [],
    transactionStatus: payoutOrderApi.transactionStatus,
    amount: `${payoutOrderApi.amount} ${payoutOrderApi.currency}`,
    psp: payoutOrderApi.psp,
    processingType: payoutOrderApi.processingType,
    moderateBackOfficeAdminEmail: payoutOrderApi.moderateBackOfficeAdminEmail,
    whitelabelSlug: payoutOrderApi.whitelabelSlug,
    takeableTransaction: payoutOrderApi.takeableTransaction,
    isModerationAvailable: payoutOrderApi.isModerationAvailable,
    isDisabledPopover: !isBlockHoldMessage && !isPaymentStatusInfo,
    isPaymentStatusInfo,
    paymentStatusInfo: payoutOrderApi.paymentStatusInfo,
    isBlockHoldMessage,
    blockHoldMessage: payoutOrderApi.blockHoldMessage,
    transactionStatusTagName:
      payoutOrderApi.transactionStatus ? colorStatusMap[payoutOrderApi.transactionStatus] : '—',
    bpWlTransactionId: payoutOrderApi.bpWlTransactionId,
  };
};
